import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class OnboardingService {
  private readonly ONBOARDING_COMPLETED_KEY = 'spOnboardingCompleted';

  constructor() {}

  shouldShowOnboarding(): boolean {
    // For development, you might want to temporarily bypass this:
    // return true;
    return !localStorage.getItem(this.ONBOARDING_COMPLETED_KEY);
  }

  markOnboardingAsCompleted(): void {
    localStorage.setItem(this.ONBOARDING_COMPLETED_KEY, 'true');
  }

  // Optional: Call this during development to reset the onboarding state
  resetOnboardingState(): void {
    localStorage.removeItem(this.ONBOARDING_COMPLETED_KEY);
  }
} 